import { render, staticRenderFns } from "./AccountRetrospect.vue?vue&type=template&id=2c4a7b18"
import script from "./AccountRetrospect.vue?vue&type=script&lang=js"
export * from "./AccountRetrospect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports